import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import {
  schemaShouldShowConfigTypes,
  schemaTypes,
} from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const isEnabled = ApplicationDomainUtility.isCrypto ? true : window?.isAdmin;

const configuration = {
  type: 'todayAVWAP',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'todayAVWAP',
    name: 'todayAvwap',
    config: {
      candleInterval: '5 minutes',
      valuePaths: ['item0.equity'],
      multiplier: 1,
      anchorBy: 'high',
      startTime: '09:30',
      endTime: '10:30',
    },
  },
  inputSchema: [
    {
      name: 'startTime',
      type: pipeInputSchemaTypes.timeOfDay,
      label: 'Start Time',
    },
    {
      name: 'endTime',
      type: pipeInputSchemaTypes.timeOfDay,
      label: 'End Time',
    },
    {
      name: 'anchorBy',
      label: 'Anchor By',
      type: pipeInputSchemaTypes.select,
      options: ['high', 'low'],
    },
  ],
  searchTerms: ['Today AVWAP'],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future],
  },
  buildOutputSchema: ({ type, name }) => {
    const properties = ['vwap', 'upperBand', 'lowerBand'];

    return _.map(properties, (property) => {
      return {
        name: `${name}.${property}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: name === property ? name : `${name} ${property}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name,
      };
    });
  },
  isEnabled: isEnabled,
};
export default configuration;
